import { useRealtimeLastTradesFeatureFlag } from "#/hooks/featureFlags/useRealtimeLastTradesFeatureFlag";
import { useLastOptionTradesByInstrument } from "#/hooks/useLastOptionTradesByInstrument";
import { useLastPerpTradesByInstrument } from "#/hooks/useLastPerpTradesByInstrument";
import { useAccountHistory } from "#/services/kyan/hooks/useAccountHistory";

import { Channel, type WorkerToMainMessage } from "../../types/app/messages";

export const useProcessEvents = () => {
  const { isRealtimeLastTradesEnabled } = useRealtimeLastTradesFeatureFlag();

  const { refetch: refetchLastPerpsTradesByInstrument } =
    useLastPerpTradesByInstrument();
  const { refetch: refetchLastOptionTradesByInstrument } =
    useLastOptionTradesByInstrument();
  const { refetch: refetchAccountHistory } = useAccountHistory();

  const processEvents = (message: WorkerToMainMessage) => {
    if (message.channel !== Channel.Trade) return;

    refetchAccountHistory();

    if (isRealtimeLastTradesEnabled) return;

    refetchLastPerpsTradesByInstrument?.();
    refetchLastOptionTradesByInstrument();
  };

  return {
    processEvents,
  };
};
